<template>
  <v-container fluid class="px-0">
    <v-row align="baseline" class="mb-3">
      <v-col cols="12" md="12">
        <el-button
          v-if="showIkeltiSavoTeise"
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="ikeltiSavoTeise()"
          >{{ $t('Įkelti savo turtines teises') }}</el-button
        >
        <el-button
          v-if="showIkeltiSavoTurta"
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="ikeltiSavoTurta()"
          >{{ $t('Įkelti savo NT') }}</el-button
        >
        <el-button
          v-if="showIkeltiSeimosTurtas"
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="ikeltiSeimosTurtas()"
          >{{ $t('Įkelti NT') }}</el-button
        >
        <el-button
          v-if="showPagalAdresa"
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="adresasTurtas()"
          >{{ $t('Paieška pagal adresą') }}</el-button
        >
        <el-button
          v-if="showPaieskaTeise"
          primary
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="paieskaTeise()"
          >{{ $t('Paieška') }}</el-button
        >
        <el-button
          v-if="showPasalintiTurta"
          small
          :loading="loading"
          :disabled="isSearching"
          @click.native="pasalintiTurtas()"
          >{{ $t('Pašalinti įkeltus NT') }}</el-button
        >
      </v-col>
    </v-row>
    <v-row v-if="showFail" align="baseline" class="mb-0">
      <v-col cols="12">
        <el-savitarna-alert type="error">
          {{ failMsg }}
        </el-savitarna-alert>
      </v-col>
    </v-row>
    <form
      v-if="showSearchForm"
      @keydown.enter.prevent="searchTurtas()"
      @keydown.esc.prevent="cancelSearch()"
    >
      <v-row align="baseline" class="mb-0">
        <v-col cols="12" md="8">
          <el-text-field
            :label="$t('Unikalus numeris')"
            :tooltip="`${ntrTooltipPrefix} Turtas. Unikalus numeris. Paieškai`"
            :readonly="isSearching"
            hide-details="auto"
            v-model="tur_identifikatorius"
          />
        </v-col>

        <v-col cols="12" md="4">
          <el-button
            primary
            @click.native="searchTurtas()"
            :loading="loading"
            :disabled="isSearching"
            >{{ $t('Ieškoti') }}</el-button
          >
          <el-button
            @click.native="cancelSearch()"
            :loading="loading"
            :disabled="isSearching"
            >{{ $t('Išvalyti') }}</el-button
          >
        </v-col>
      </v-row>
    </form>

    <modal-ntr-turtas-sarasas
      v-model="showTurtasSarasas"
      :is-adresas="turtasSarasasAdresas"
      :turtas-teise="turtasTeise"
      @updateTurtasList="updateTurtasList"
    />
    <modal-ntr-teise-sarasas
      v-model="showTeiseSarasas"
      :savo-turtas="teiseSavoTurtas"
      :teise-autosave="teiseAutosave"
      @updateTurtasList="updateTurtasList"
      @cancelTeiseSarasas="cancelTeiseSarasas"
    />
    <modal-confirm
      :title="modalConfirmTitle"
      :text="modalConfirmText"
      :action="modalConfirmAction"
      v-model="showConfirm"
      @confirmIkeltiTurtas="confirmIkeltiTurtas"
      @cancelConfirm="closeConfirm"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import busena from '@/mixins/busenaNtr'
import tooltipNtr from '@/mixins/tooltipNtr'
import ModalNtrTurtasSarasas from '../modals/ModalNtrTurtasSarasas'
import ModalNtrTeiseSarasas from '../modals/ModalNtrTeiseSarasas'
import ModalConfirm from '../modals/ModalConfirm'

export default {
  name: 'PrasymasTurtasSearch',
  components: {
    ModalNtrTurtasSarasas,
    ModalNtrTeiseSarasas,
    ModalConfirm,
  },
  mixins: [busena, tooltipNtr],
  props: {
    turtasTeise: { type: Boolean, default: false },
    turtasLength: { type: Number, default: 0 },
    pageloading: { type: Boolean, default: false },
  },
  data() {
    return {
      tur_identifikatorius: null,
      isSearching: false,
      loading: false,
      showFail: false,
      failMsg: null,
      search: null,
      itemsPerPageOptions: [10, 50],
      pageSize: 10,
      showTurtasSarasas: false,
      showTeiseSarasas: false,
      showConfirm: false,
      modalConfirmTitle: null,
      modalConfirmText: null,
      modalConfirmAction: null,
      modalConfirmItem: null,
      turtasSarasasAdresas: false,
      teiseSavoTurtas: false,
      teiseAutosave: false,
    }
  },
  computed: {
    ...mapGetters(['prasymasID']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    searchTurIdentifikatorius() {
      return (
        this.tur_identifikatorius ?? (this.isLocal ? '4193-9012-2010' : null)
      )
    },
    showIkeltiSeimosTurtas() {
      return this.isPrasymasSeima && this.isPrasymasIsregistravimas
    },
    showIkeltiSavoTurta() {
      return (
        this.isPrasymasBendra ||
        (this.isPrasymasNuoma && this.isPrasymasNuomotojas) ||
        (this.isPrasymasPanauda && this.isPrasymasPanaudaDavejas) ||
        (this.isPrasymasPreliminari && this.isPrasymasPardavejas)
      )
    },
    showIkeltiSavoTeise() {
      return (
        this.isPrasymasSubnuoma &&
        this.isPrasymasSubnuomotojas &&
        this.isPrasymasIregistravimas
      )
    },
    showPasalintiTurta() {
      return (
        this.isPrasymasBendra ||
        (this.isPrasymasNuoma && this.isPrasymasIregistravimas) ||
        (this.isPrasymasPanauda && this.isPrasymasIregistravimas) ||
        (this.isPrasymasSubnuoma && this.isPrasymasIregistravimas) ||
        (this.isPrasymasPreliminari && this.isPrasymasIregistravimas)
      )
    },
    showPagalAdresa() {
      return (
        (this.isPrasymasSeima && this.isPrasymasIregistravimas) ||
        (this.isPrasymasSeima && this.isPrasymasPerkelimas) ||
        (this.isPrasymasBendra && this.isPrasymasIregistravimas) ||
        (this.isPrasymasNuoma && this.isPrasymasIregistravimas) ||
        (this.isPrasymasPanauda && this.isPrasymasIregistravimas) ||
        (this.isPrasymasPreliminari && this.isPrasymasIregistravimas)
      )
    },
    showPaieskaTeise() {
      return this.isPrasymasSubnuoma && this.isPrasymasIregistravimas
    },
    showSearchForm() {
      return !this.isPrasymasIsregistravimas && !this.isPrasymasSubnuoma
    },
  },
  watch: {
    showTeiseSarasas(val) {
      if (!val) {
        this.loading = false
      }
    },
  },

  created() {
    //
  },
  methods: {
    searchTurtas() {
      if (this.searchTurIdentifikatorius === null) {
        return false
      }
      this.loading = true
      this.showFail = false

      if (!this.validateTurIdentifikatorius()) {
        window._VMA.$emit(
          'DATA_ERROR',
          this.$t('Įvestas neteisingas unikalus numeris, patikslinkite.')
        )
        this.loading = false
        return
      }

      const data = {
        tur_identifikatorius: this.searchTurIdentifikatorius,
        pra_turtas_teise: this.turtasTeise,
      }

      this.$axios
        .post(`ntrpaslaugos/prasymas/${this.prasymasID}/turtas/paieska`, data)
        .then(res => {
          this.updateTurtasList()
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    ikeltiSeimosTurtas() {
      this.loading = true
      this.showFail = false

      this.$axios
        .post(`ntrpaslaugos/prasymas/${this.prasymasID}/turtas/uzkrauti`)
        .then(res => {
          this.updateTurtasList()
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          // window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    pasalintiTurtas() {
      this.loading = true
      this.showFail = false

      this.$axios
        .post(
          `ntrpaslaugos/prasymas/${this.prasymasID}/turtas/pasalinti-ikeltus`
        )
        .then(res => {
          this.updateTurtasList()
        })
        .catch(err => {
          this.failMsg = err.response.data.message
          this.showFail = true
          window._VMA.$emit('DATA_ERROR', this.failMsg)
        })
        .finally(() => {
          this.loading = false
        })
    },
    adresasTurtas() {
      this.showFail = false
      this.turtasSarasasAdresas = true
      this.showTurtasSarasas = true
    },
    ikeltiSavoTurta() {
      this.showFail = false
      this.turtasSarasasAdresas = false
      this.showTurtasSarasas = true
    },
    ikeltiSavoTeise() {
      this.showFail = false
      this.teiseSavoTurtas = true
      this.teiseAutosave = true
      // this.showTeiseSarasas = true
      this.loading = true
    },
    paieskaTeise() {
      this.showFail = false
      this.teiseSavoTurtas = false
      this.teiseAutosave = false
      this.showTeiseSarasas = true
    },
    validateTurIdentifikatorius() {
      const unikalus = this.searchTurIdentifikatorius
        .replaceAll('-', '')
        .replaceAll(':', '')
      return unikalus.length == 12 || unikalus.length == 16
    },
    cancelSearch() {
      this.tur_identifikatorius = null
      this.showFail = false
      this.$emit('cancelSearch')
    },
    cancelTeiseSarasas() {
      this.teiseAutosave = false
      this.showTeiseSarasas = false
      this.loading = false
    },
    updateTurtasList(failMsg) {
      this.tur_identifikatorius = null
      if (failMsg) {
        this.failMsg = failMsg
        this.showFail = true
      }
      this.$emit('updateTurtasList')
      this.teiseAutosave = false
      this.loading = false
    },
    openConfirmIkeltiTurtas() {
      this.modalConfirmTitle = this.$t('Įkelti nekilnojamajį turtą')
      this.modalConfirmText = this.$t(
        'Ar tikrai norite įkelti viso savo nekilnojamojo turto duomenis?'
      )

      this.modalConfirmAction = 'IkeltiTurtas'
      this.showConfirm = true
    },
    confirmIkeltiTurtas() {
      this.showConfirm = false
      this.ikeltiTurtas()
    },
    closeConfirm() {
      this.showConfirm = false
    },
  },
}
</script>
<style lang="scss" scoped>
.teise-label {
  display: inline;

  p {
    margin: 0;
  }
  p.teise-bold {
    font-weight: 600;
  }
}
</style>
